<template>
    <div class="distributor-activity-list">
        <special-index v-show="special && special['activity/detail'+activity_id]" :page-path="'activity/detail'" :item-id="activity_id"></special-index>
        <div v-show="!special || !special['activity/detail'+activity_id]">
            <div class="common-header-wrap">
                <mt-header class="common-header" title="تفاصيل النشاط">
                    <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                </mt-header>
            </div>
            <div class="brand_detail_banner" v-if="activity">
                <div class="wqvue-image img">
                    <img style="min-width: 1px; width: 100%; height: auto; transform: none; left: 0px; top: 0px; position: relative; vertical-align: top;" :src="activity.activity_banner_mobile_url" />
                </div>
                <div class="brand_detail_info">

                    <div class="detail_info_other">
                        <span class="info_other_title">{{activity.activity_title}}</span>
                    </div>
                    <div class="detail_info_all">
                        {{activity.activity_desc}}
                    </div>
                </div>
            </div>
            <div class="ping_list">
                <div class="row_list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                    <div v-if="activitydetail_list">
                        <div @click="goGoodsDetail(item)" class="item" v-for="item in activitydetail_list" :key="item.goods_id">
                            <div class="cover bg_stamp">
                                <div class="wqvue-image img">
                                    <img :src="item.goods_image_url" style="min-width: 1px; width: 100%; height: auto; transform: none; left: 0px; top: 0px; position: relative; vertical-align: top;" />
                                </div>
                                <!---->
                            </div>
                            <div class="info">
                                <div class="name">
                                    <div class="tag_container">
                                    </div>{{item.goods_name}}
                                </div>
                                <div class="tags">
                                    <span class="span">{{item.store_name}}</span>
                                </div>
                                <div class="price">
                                    <span class="span">$<span class="em">{{parseFloat(item.goods_price)}}</span></span>
                                    <span class="del" v-if="item.goods_marketprice">${{parseFloat(item.goods_marketprice)}}</span>
                                </div>
                                <div class="btn">
                                  إذهب لشراء
                                </div>
                            </div>
                        </div>
                    </div>
                    <empty-record v-if='activitydetail_list && !activitydetail_list.length'></empty-record>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import EmptyRecord from '../../EmptyRecord'
import SpecialIndex from '../special/Index'
import { getActivityDetail } from '../../../api/homeActivity'
import { Toast, Indicator } from 'mint-ui'
export default {

  name: 'HomeDocument',
  components: {
    EmptyRecord,
    SpecialIndex
  },
  data () {
    return {
      activity_id: this.$route.query.activity_id,
      activity: false,
      activitydetail_list: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },

  created: function () {

  },
  computed: {
    ...mapState({
      special: state => state.home.special
    })
  },
  methods: {
    loadMore () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.getActivityList(true)
      }
    },
    getActivityList () {
      Indicator.open()
      getActivityDetail(Object.assign({ activity_id: this.activity_id }, this.params)).then(res => {
        this.activity = res.result.activity

        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        if (this.activitydetail_list) {
          this.activitydetail_list = this.activitydetail_list.concat(res.result.activitydetail_list)
        } else {
          this.activitydetail_list = res.result.activitydetail_list
        }
        this.loading = false
      }).catch(error => {
        Indicator.close()
        Toast(error.message)
        this.loading = false
      })
    },
    goGoodsDetail (item) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': item.goods_id } })
    }
  }

}
</script>
<style  lang="scss" scoped>

    .brand_detail_banner {
        position: relative;
        min-height: 11.25rem;
        margin-bottom: .5rem
    }

    .brand_detail_banner .timer {
        position: absolute;
        top: 0;
        left: 0;
        height: 1rem;
        padding: 0 .4rem;
        background: hsla(0,0%,100%,.5);
        border-radius: 0 0 .5rem;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #e43f42;
        line-height: 1rem;
        text-align: center;
        z-index: 2
    }

    .brand_detail_banner .img {
        width: 100%;
        height: 6rem
    }

    .brand_detail_info {
        position: relative;
        background-color: #fff;
        box-shadow: 0 .25rem .75rem 0 rgba(0,0,0,.05);
        border-radius: .4rem;
        width: 17.25rem;
        min-height: 4.75rem;
        margin: -10px auto 0;
        padding: .5rem;
        bottom: 1rem;
        box-sizing: border-box
    }

    .brand_detail_info .detail_info_other {
        text-align: center;
    }

    .brand_detail_info .detail_info_other .info_other_title {
        font-family: PingFang-SC-Bold;
        font-size: .9rem;
        color: #333;
        font-weight: 700;
        max-width: 5.75rem;
        overflow: hidden
    }

    .brand_detail_info .detail_info_other .info_other_mark {
        font-family: PingFang-SC-Medium;
        font-size: .6rem;
        max-width: 4rem;
        overflow: hidden;
        color: #333
    }

    .brand_detail_info .detail_info_all {
        font-family: PingFang-SC-Regular;
        font-size: .6rem;
        color: #999;
        padding: .5rem .25rem 0
    }

    .ping_list {
        margin-top: .5rem
    }

    .row_list .item {
        position: relative;
        margin: 0 .5rem;
        height: 6.75rem;
        overflow: hidden;
        padding-bottom: .6rem;
        border-bottom: 1px solid #f7f7f7
    }

    .row_list .cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 6.75rem;
        height: 6.75rem
    }

    .row_list .cover .img {
        display: block;
        width: 6.75rem;
        height: 6.75rem;
        border-radius: .25rem 0 0 .25rem
    }

    .row_list .stamp {
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 0 .3rem;
        height: .8rem;
        line-height: .8rem;
        color: #fff;
        font-size: .6rem;
        border-radius: .7rem 0 .7rem .7rem
    }

    .row_list .stamp.bg_red {
        background: -webkit-gradient(linear,left top,right top,from(#e93b3d),to(#fe9373));
        background: -webkit-linear-gradient(left,#e93b3d,#fe9373);
        background: linear-gradient(90deg,#e93b3d,#fe9373);
        box-shadow: 0 .15rem .3rem rgba(233,59,61,.2)
    }

    .row_list .stamp.bg_orange {
        background: -webkit-gradient(linear,left top,right top,from(#ff7901),to(#ffc30a));
        background: -webkit-linear-gradient(left,#ff7901,#ffc30a);
        background: linear-gradient(90deg,#ff7901,#ffc30a);
        box-shadow: 0 .15rem .3rem rgba(255,157,5,.2)
    }

    .row_list .stamp.bg_turblue {
        background: -webkit-gradient(linear,left top,right top,from(#39aaa8),to(#6bc0be));
        background: -webkit-linear-gradient(left,#39aaa8,#6bc0be);
        background: linear-gradient(90deg,#39aaa8,#6bc0be);
        box-shadow: 0 .15rem .3rem rgba(80,180,178,.2)
    }

    .row_list .info {
        position: relative;
        margin-left: 7.5rem;
        padding-top: .5rem;
        height: 6.75rem;
        box-sizing: border-box
    }

    .row_list .name {
        margin: 0 0 .3rem;
        color: #333;
        font-family: PingFangSC-Semibold;
        font-size: .7rem;
        white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all
    }

    .row_list .tag_container {
        display: inline-block;
        margin-bottom: -2px
    }

    .row_list .sale_icon {
        float: left;
        width: 28px;
        height: 14px;
        margin-right: 3px
    }

    .row_list .ziying_tag {
        float: left;
        width: 24px;
        height: 14px;
        margin-right: 3px
    }

    .row_list .logistics_tag {
        float: left;
        width: 49px;
        height: 14px;
        margin-right: 3px
    }

    .row_list .tags {
        margin-bottom: .2rem;
        height: .7rem;
        white-space: nowrap;
        overflow: hidden;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex
    }

    .row_list .tags,.row_list .tags .span {
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center
    }

    .row_list .tags .span {
        display: -webkit-inline-box;
        display: -webkit-inline-flex;
        display: inline-flex;
        padding: 0 .3rem;
        font-family: PingFangSC-Regular;
        font-size: .5rem;
        color: #f43638;
        border: 1px solid #ffcccd;
        border-radius: 4px;
        box-sizing: border-box;
        height: .6rem
    }

    .row_list .tags .span:not(:last-child) {
        margin-right: .25rem
    }

    .row_list .tags .span_android {
        line-height: normal;
        padding: .05rem .3rem
    }

    .row_list .price {
        position: absolute;
        bottom: .45rem;
        left: 0;
        color: #ff4142;
        font-size: .6rem;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: start;
        -webkit-justify-content: flex-start;
        justify-content: flex-start;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        height: 1.1rem;
        overflow: hidden
    }

    .row_list .price .fxprice {
        margin-left: .25rem
    }

    .row_list .price .span {
        height: 1.1rem;
        line-height: 1.1rem;
        margin-right: .25rem;
        font-size: .7rem;
        font-family: JDZH-Regular
    }

    .row_list .price .span .em {
        font-size: 1.1rem
    }

    .row_list .price .span .normal {
        font-size: .7rem
    }

    .row_list .price .del {
        color: #999;
        text-decoration: line-through
    }

    .row_list .desc {
        position: absolute;
        bottom: .6rem;
        left: 0;
        color: #999;
        font-size: .6rem
    }

    .row_list .desc .del {
        text-decoration: line-through
    }

    .row_list .btn {
        position: absolute;
        bottom: .45rem;
        right: .5rem;
        width: 3.25rem;
        height: 1.5rem;
        line-height: 1.5rem;
        color: #fff;
        font-size: .7rem;
        text-align: center;
        border-radius: .25rem;
        background: -webkit-gradient(linear,left top,right top,from(#e93b3d),to(#ff9474));
        background: -webkit-linear-gradient(left,#e93b3d,#ff9474);
        background: linear-gradient(90deg,#e93b3d,#ff9474);
        box-shadow: 0 .15rem .3rem rgba(233,59,61,.2)
    }

    .row_list+.ping_floortit {
        margin-top: -.75rem
    }

</style>
